import GroupCheckbox from './GroupCheckbox';

export default GroupCheckbox;
